import React from 'react';
import Card from './Card';
import './CardHand.css';

/**
 * Display a hand of cards in a fan layout
 */
const CardHand = ({ cards, showCards = true, onCardClick, clickable = false, playableIndices = [] }) => {
  if (!cards || cards.length === 0) {
    return (
      <div className="card-hand empty">
        <span className="no-cards">No cards remaining! 🎉</span>
      </div>
    );
  }

  return (
    <div className="card-hand">
      <div className="cards-container">
        {cards.map((card, index) => {
          const isPlayable = playableIndices.includes(index);
          const isClickable = clickable && (playableIndices.length === 0 || isPlayable);
          return (
            <div 
              key={card.id} 
              className={`card-wrapper ${isClickable ? 'clickable' : ''} ${isPlayable ? 'playable' : ''} ${!isPlayable && playableIndices.length > 0 ? 'not-playable' : ''}`}
              style={{
                '--index': index,
                '--total': cards.length,
                '--rotation': `${(index - (cards.length - 1) / 2) * 8}deg`,
                '--offset': `${(index - (cards.length - 1) / 2) * 25}px`
              }}
              onClick={() => isClickable && onCardClick && onCardClick(card, index)}
            >
              {showCards ? (
                <Card card={card} />
              ) : (
                <div className="card back">
                  <span>🎱</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="card-count">
        <span className="count-number">{cards.length}</span>
        <span className="count-label">cards</span>
      </div>
    </div>
  );
};

export default CardHand;


